import * as React from 'react';
import ToolIconButton from './ToolIconButton';

interface LineColorRadioButtonSetProps {
  readonly activeIndex: number;
  readonly disabled?: boolean;
  readonly onClick?: (index: number) => void;
}

const LineColorRadioButton: React.SFC<LineColorRadioButtonSetProps> = (props) => {
  const { activeIndex, disabled, onClick } = props;

  return <>
    <ToolIconButton
      onClick={() => { if (onClick != null) { onClick(0); } } }
      iconName="colorchip-red"
      active={activeIndex === 0}
      disabled={disabled}
      title="赤"
      ariaLabel="line-color-red" />
    <ToolIconButton
      onClick={() => { if (onClick != null) { onClick(1); } } }
      iconName="colorchip-blue"
      active={activeIndex === 1}
      disabled={disabled}
      title="青"
      ariaLabel="line-color-blue" />
    <ToolIconButton
      onClick={() => { if (onClick != null) { onClick(2); } } }
      iconName="colorchip-yellow"
      active={activeIndex === 2}
      disabled={disabled}
      title="黄"
      ariaLabel="line-color-yellow" />
    <ToolIconButton
      onClick={() => { if (onClick != null) { onClick(3); } } }
      iconName="colorchip-green"
      active={activeIndex === 3}
      disabled={disabled}
      title="緑"
      ariaLabel="line-color-green" />
    <ToolIconButton
      onClick={() => { if (onClick != null) { onClick(4); } } }
      iconName="colorchip-black"
      active={activeIndex === 4}
      disabled={disabled}
      title="黒"
      ariaLabel="line-color-black" />
  </>;
};

export default LineColorRadioButton;
